import { type RefObject, useLayoutEffect, useState } from 'react';

import { isOverflowing } from '../utils/overflow';

/**
 * Of de tekst in `ref` door line-clamp wordt afgekapt; opnieuw gemeten bij elke maatwijziging.
 * Bij `enabled=false` blijft de laatste meting staan.
 */
export function useIsClamped(ref: RefObject<HTMLElement | null>, enabled: boolean): boolean {
  const [clamped, setClamped] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || !enabled) return;
    const update = () => setClamped(isOverflowing(el.scrollHeight, el.clientHeight));
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, enabled]);

  return clamped;
}
